<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Cập nhật Ưu tiên
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div class="text-caption text-uppercase font-weight-medium mb-4">
          Tài khoản này sẽ được ưu tiên kích hoạt và hoàn thành hồ sơ mà không bị giới hạn bởi thời gian mở đóng cổng.
        </div>
        <div class="mb-3 text-body-1 black--text">1. Thông tin tài khoản</div>
        <div class="mb-1">
          Số điện thoại: <strong>{{ $get(item, 'username') }}</strong>
        </div>
        <div class="mb-1">
          Kích hoạt OTP: <strong>{{ $get(item, 'isConfirmedOTP', false) ? 'Đã kích hoạt' : 'Chưa kích hoạt' }}</strong>
        </div>
        <div class="mb-1">
          Chỉnh sửa lần cuối lúc: <strong>{{ $get(item, 'bypassedAt') | getBypassedAt }}</strong>
        </div>
        <div class="mb-1">
          Chỉnh sửa lần cuối bởi: <strong>{{ $get(item, 'bypassedBy.name', '-') }}</strong>
        </div>
        <v-divider class="my-3" />
        <div class="mb-3 text-body-1 black--text">2. Thông tin cấu hình</div>
        <v-select
          :items="[
            {t: 'Bỏ ưu tiên', v: false},
            {t: 'Ưu tiên', v: true},
          ]"
          item-text="t"
          item-value="v"
          v-model="isBypassed"
          placeholder="Ưu tiên"
          clearable
          outlined
          dense
          hide-details
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-btn color="admin" class="white--text" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from 'vuex'
import {get} from 'lodash'
import moment from 'moment'
export default {
  data: () => ({dialog: false, loading: false, item: null, isBypassed: false, id: ''}),
  methods: {
    ...mapActions({upgradeWhitelist: 'user/upgradeWhitelist'}),
    openDialog(item = {}) {
      this.id = get(item, 'id', '')
      this.item = item
      this.isBypassed = get(item, 'isBypassed', 'false')
      this.dialog = true
    },
    closeDialog() {
      this.reset()
      this.dialog = false
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSubmit() {
      try {
        this.loading = true
        await this.upgradeWhitelist({id: this.id, isBypassed: this.isBypassed})
        this.$emit('onRefresh')
        this.$alert.success('Đánh dấu ưu tiên thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  filters: {
    getBypassedAt: v => (v ? moment(v).format('DD/MM/YYYY HH:mm:ss') : '-'),
  },
}
</script>